import React, { useContext, useState, useEffect } from 'react';
import { observer } from 'mobx-react';
import { compose } from 'recompose';

import config from '../../../config';
import UserContext from '../../../context/UserContext';
import InstagramUser, { accountStatus } from '../../../Model/InstagramUser';
import useComponentMounted from '../../../hooks/useComponentMounted';
import useToolsNavigation from '../../hooks/useToolsNavigation';
import texts from './texts.json';
import { StyledIframe, StyledAlert } from './styles';

const { looker: { dashboardUrl } } = config;

const InstagramAnalytics = () => {
  const { userId: coachId } = useContext(UserContext);
  const isComponentMountedRef = useComponentMounted();
  const { navigateToAnalyticsConfigPage } = useToolsNavigation();
  const [isInstaConnected, setIsInstaConnected] = useState(true);

  useEffect(() => {
    const init = async () => {
      const instaUserCol = await InstagramUser.getInstaUserByCoachId(coachId);
      if (isComponentMountedRef.current) {
        const instaUser = instaUserCol.docs[0];
        const connectedStatus = instaUser?.accountStatus;
        setIsInstaConnected(connectedStatus === accountStatus.AUTHORIZED);
      }
    };
    if (coachId) {
      init();
    }
  }, [coachId, isComponentMountedRef]);
  const lookerDashboardUrl = `${dashboardUrl}?params=${encodeURIComponent(JSON.stringify({
    coach: coachId, coachid: coachId,
  }))}`;

  return (
    <>
      {!isInstaConnected && (
        <StyledAlert
          severity="warning"
          onClick={() => navigateToAnalyticsConfigPage(coachId)}
        >
          { texts.connectInstagramWarning }
        </StyledAlert>
      )}
      <StyledIframe
        src={lookerDashboardUrl}
        allowFullScreen
        sandbox="
          allow-storage-access-by-user-activation
          allow-scripts
          allow-same-origin
          allow-popups
          allow-popups-to-escape-sandbox
          allow-downloads
        "
        title={texts.title}
      />
    </>
  );
};
export default compose(observer)(InstagramAnalytics);
